document.addEventListener('DOMContentLoaded', function () {

  const popup = document.getElementById('ProductEnquiryPopup');

  if (!popup) {
    console.log('Product Enquiry Popup not found.');
    return;
  }

  console.log('Product Enquiry JS loaded successfully.');

  const overlay = popup.querySelector('.product-enquiry-overlay');
  const closeButton = popup.querySelector('.product-enquiry-close');

  const productImage = document.getElementById('ProductEnquiryImage');
  const productTitle = document.getElementById('ProductEnquiryTitle');
  const productPrice = document.getElementById('ProductEnquiryPrice');
  const productId = document.getElementById('ProductEnquiryProductId');
  const productUrl = document.getElementById('ProductEnquiryProductUrl');

  const mobileInput = document.getElementById('ProductEnquiryMobile');
  const quantityInput = document.getElementById('ProductEnquiryQuantity');
  const descriptionInput = document.getElementById('ProductEnquiryDescription');

  const mobileError = document.getElementById('ProductEnquiryMobileError');
  const submitButton = document.getElementById('ProductEnquirySubmit');


  /* =========================================
     OPEN POPUP
     ========================================= */

  function openEnquiryPopup(button) {

    const title = button.dataset.productTitle || '';
    const price = button.dataset.productPrice || '';
    const image = button.dataset.productImage || '';
    const id = button.dataset.productId || '';
    const url = button.dataset.productUrl || '';

    productTitle.textContent = title;
    productPrice.textContent = price;

    if (image) {
      productImage.src = image;
      productImage.alt = title;
    }

    productId.value = id;
    productUrl.value = url;

    mobileInput.value = '';
    quantityInput.value = '';
    descriptionInput.value = '';
    mobileError.textContent = '';

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      mobileInput.focus();
    }, 150);
  }


  /* =========================================
     CLOSE POPUP
     ========================================= */

  function closeEnquiryPopup() {

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';

  }


  /* =========================================
     ENQUIRY BUTTON CLICK
     ========================================= */

  document.addEventListener('click', function (event) {

    const button = event.target.closest('.product-enquiry-btn');

    if (!button) {
      return;
    }

    console.log('Enquiry button clicked.');

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    openEnquiryPopup(button);

  }, true);


  /* =========================================
     CLOSE EVENTS
     ========================================= */

  if (closeButton) {
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      closeEnquiryPopup();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeEnquiryPopup);
  }


  /* =========================================
     ESC KEY
     ========================================= */

  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      popup.classList.contains('is-open')
    ) {
      closeEnquiryPopup();
    }

  });


  /* =========================================
     MOBILE VALIDATION
     ========================================= */

  if (mobileInput) {

    mobileInput.addEventListener('input', function () {

      mobileError.textContent = '';

      this.value = this.value.replace(/\D/g, '');

    });

  }


  /* =========================================
     GET QUOTES
     ========================================= */

  if (submitButton) {

    submitButton.addEventListener('click', function () {

      const mobile = mobileInput.value.trim();

      mobileError.textContent = '';

      if (!mobile) {

        mobileError.textContent =
          'Please enter your mobile number.';

        mobileInput.focus();

        return;

      }

      if (!/^[6-9]\d{9}$/.test(mobile)) {

        mobileError.textContent =
          'Please enter a valid 10-digit mobile number.';

        mobileInput.focus();

        return;

      }

      console.log('Product Enquiry', {
        productId: productId.value,
        productTitle: productTitle.textContent,
        productPrice: productPrice.textContent,
        productUrl: productUrl.value,
        mobile: mobile,
        quantity: quantityInput.value,
        description: descriptionInput.value
      });

      alert('Thank you! Your enquiry has been received.');

      closeEnquiryPopup();

    });

  }

});